module.exports = __webpack_public_path__ + "img/elipse-1.391a1f38.svg";